import React, {Component} from 'react'
import {Button} from "react-bootstrap";
import KoszykService from "../KoszykService";

export default class WczytajNumerBiletu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            idBi: ''
        }

        this.onChangeIdBi = this.onChangeIdBi.bind(this)
    }

    componentDidMount() {
        if (this.props.idBi !== undefined && this.props.idBi !== null) {
            this.setState({idBi: this.props.idBi})
            this.checkTransactionId(this.props.idBi)
        }
    }

    onChangeIdBi(e) {
        this.setState({idBi: e.target.value})
    }

    checkTransactionId(idBi) {
        this.props.setButtonLoader(true)
        KoszykService.getDokumentyBiletu(idBi).then((response) => {
            if (response.data.length === 0) {
                this.props.setIdValid(false)
                this.props.setButtonLoader(false)
            } else {
                this.props.setBiletData(response.data)
                this.props.setIdValid(true)
                this.props.setIdSuccess(true)
                this.props.setIdBi(this.state.idBi)
            }
        })
    }

    render() {
        return <div>
            <div className="row" style={{alignItems: 'center', width: '90%', margin: '0 auto'}}>
                <div className="col-12">
                    <div className="row">
                        <div className={'col-12'}>
                            <h2 className="text-center" style={{fontWeight: 'bold'}}>Faktura VAT</h2>
                        </div>
                        <div className="col-12">
                            <hr/>
                            <p style={{fontWeight: 'normal'}}>Wygenerowanie faktury VAT jest możliwe tylko i wyłącznie
                                po uprzednim podaniu numeru NIP w procesie zakupu biletów.
                                Aby wygenerować fakturę VAT należy podać numer biletu dostępny w wiadomości e-mail
                                zawierającej zakupione bilety.</p>
                            <hr/>
                        </div>
                        <div className="col-12">
                            Numer biletu:
                            <input type="text" className="form-control" value={this.state.idBi}
                                   onChange={this.onChangeIdBi}/>
                            {!this.props.idValid ?
                                <div className="niepoprawneDaneWynajem">Niepoprawny numer biletu.</div> : null}
                        </div>
                        <div className="col-12">
                            <div className="row" style={{paddingTop: '15px'}}>
                                <div className="col-12 text-right">
                                    <Button bsStyle='success' disabled={this.props.buttonLoader}
                                            onClick={() => {
                                                this.checkTransactionId(this.state.idBi)
                                            }}>Dalej</Button>
                                    {this.props.buttonLoader ?
                                        <div className="loaderDim" style={{marginTop: 5}}><i
                                            className="fa fa-spinner fa-pulse fa-fw"
                                            style={{
                                                color: '#58b13d'
                                            }}> </i></div> : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/koszyk/fakturyComponents/WczytajNumerBiletu.js